import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutContainerComponent } from './layouts/layout-container.component';
import { canActivateAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';


const routes: Routes = [
  {
    path: "implicit/callback",
    component: OktaCallbackComponent,
  },
  { path: '', component: LayoutContainerComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [canActivateAuthGuard] },
  { path: '**', component: PagenotfoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
